import { useState } from 'react'

/**
 * Estado de filtro COMPARTILHADO entre as 4 telas do painel via localStorage (mesma origem),
 * para valores serializaveis em JSON (ex.: empresa selecionada = string[]). Trocar numa tela e
 * navegar para outra leva o mesmo valor (cada tela le o localStorage ao montar).
 *
 * Para periodo (datas/moment) use o usePeriodoCompartilhado, que trata a serializacao de data.
 */
export function useFiltroCompartilhado<T>(chave: string, padrao: T): [T, (v: T) => void] {
  const [valor, setValorState] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(chave)
      return raw === null ? padrao : (JSON.parse(raw) as T)
    } catch {
      return padrao
    }
  })

  const setValor = (v: T) => {
    setValorState(v)
    try {
      localStorage.setItem(chave, JSON.stringify(v))
    } catch {
      /* modo privado / storage bloqueado -> ignora */
    }
  }

  return [valor, setValor]
}
